import { blueprints } from '../blueprints/blueprints-sidecar'
import { distance } from '../lib/distance-sidecar'
import { scene } from '../main/scene-sidecar'
import { tileMapShip } from '../tiles/tileMapShip-sidecar'
import { tilesShip } from '../tiles/tilesShip-sidecar'
import { IJob, ITask } from './jobs'
import { jobs } from './jobs-sidecar'
import { jobLogger } from './jobLogger-sidecar'
import { ITileDataShip } from '../tiles/tilesDataShip'
import { setDesc } from '../ui/uiBuild'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'

export function createTask_constructHull(i: number, j: number): ITask {
  return jobs._createTask(i, j, 'construct-hull', {})
}

export function forceConstructHull(
  i: number,
  j: number,
  tileData: ITileDataShip,
) {
  let ctx = scene.getContext()
  let t = tileMapShip.getTile(ctx.mapShip, i, j)
  if (t) {
    tilesShip.setFloor(t, tileData)
  }
}

export function runTask_constructHull(job: IJob, task: ITask) {
  jobLogger.assertTaskType(task, 'construct-hull')
  let m = jobLogger.assertReserved(job)

  // Are we at the right spot?
  if (!distance.isAt(m.i, m.j, task.i, task.j)) {
    return jobLogger.failTask(job, task, 'wrong spot')
  }

  let blueprintHere = blueprints.findAtSpot(m.i, m.j, (c) => true)

  // Blueprint went missing
  if (!blueprintHere) {
    return jobLogger.failTask(job, task, 'lost blueprint')
  }

  let ctx = scene.getContext()
  let t = tileMapShip.getTile(ctx.mapShip, m.i, m.j)

  if (!t) {
    blueprints.kill(blueprintHere)
    return jobLogger.failTask(job, task, 'invalid tile')
  }

  if (t.dataFloor) {
    // || (t.dataFloor && t.d)) {
    let std = tilesDataShip.getStandard()
    let isReplacementOk = false

    if (blueprintHere.tileData === std.hull && t.dataFloor === std.floor) {
      isReplacementOk = true
    }
    if (blueprintHere.tileData === std.floor && t.dataFloor === std.hull) {
      isReplacementOk = true
    }
    if (
      blueprintHere.tileData === std.tube &&
      (t.dataFloor === std.hull || t.dataFloor === std.floor)
    ) {
      isReplacementOk = true
    }
    if (!isReplacementOk) {
      // Already something here!
      blueprints.kill(blueprintHere)
      return jobLogger.failTask(job, task, 'already has floor')
    }
  }

  tilesShip.setFloor(t, blueprintHere.tileData)

  blueprints.kill(blueprintHere)

  jobLogger.succeedTask(job, task)
}
